import { useAppSelector } from "../../redux/hooks";
const useActiveMerchants = () => {
  const merchantListFromRedux = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList.entireListOfMerchants
  );
  const filterMerchantList = merchantListFromRedux?.filter((merchant: any) => {
    const payWithPoints = merchant?.custom_fields?.field?.find(
      (field: any) => field?.name === "paywithpoints"
    );
    const isPayWithPoints = payWithPoints && payWithPoints?.value === "1";

    return merchant?.is_active === "1" && isPayWithPoints;
  });
  return filterMerchantList;
};

export default useActiveMerchants;
